export function updateIsLoading(state) {
    state.isLoading = state.currentRequests.length > 0;
    setTimeout(() => {
        window["IS_LOADING"] = state.isLoading;
    }, 500);
}

export function appendToLoading(state, key) {
    let { currentRequests } = state;
    if (!currentRequests) {
        currentRequests = [];
        state.currentRequests = currentRequests;
    }
    if (currentRequests.indexOf(key) === -1) {
        currentRequests.push(key);
    }
    updateIsLoading(state);
}

export function removeFromLoading(state, key) {
    let { currentRequests } = state;
    if (!currentRequests) {
        currentRequests = [];
        state.currentRequests = currentRequests;
    }
    let index = currentRequests.indexOf(key);
    while (index >= 0) {
        currentRequests.splice(index, 1);
        index = currentRequests.indexOf(key);
    }
    updateIsLoading(state);
}


// WEBPACK FOOTER //
// ./src/client/utils/loading.ts